import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { OtherKpDetailService } from '../../../services/other-kp-detail.service';
import { LoggingService } from '../../../../../services/logging.service';


const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-modal-other-kp-send-adjustment',
  templateUrl: './modal-other-kp-send-adjustment.component.html',
  styleUrls: ['./modal-other-kp-send-adjustment.component.sass']
})



export class ModalOtherKpSendAdjustmentComponent implements OnInit {
  spinner: NgxSpinnerService;
  http: HttpClient;
  service: OtherKpDetailService;
  params: any;
  mail = {IDAuc:undefined, AucAgreementComment:undefined };
   

  constructor(private _http: HttpClient, private _spinner: NgxSpinnerService, private _service: OtherKpDetailService, private loggingService: LoggingService) {
    this.http = _http;
    this.spinner = _spinner;
    this.service = _service;
   }

  ngOnInit() {
    $('#modalOtherKpAdjustmentSender').off('show.bs.modal shown.bs.modal hidden.bs.modal')
      .on('show.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1030);
        $('#modalOtherKpDetail').css('z-index', 1040);
      })
      .on('shown.bs.modal', function () {
        $('#modalOtherKpAdjustmentSender').css('z-index', 1070);
        $('.modal-backdrop:last').css('z-index', 1065);
      })
      .on('hidden.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1041);
        $('#modalOtherKpDetail').css('z-index', 1060);
      });
  }

  cleannField(){
    this.mail.AucAgreementComment = undefined;
  }

  onSave() {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.ModalOtherKpSendAdjustmentComponent.onSave', null, 'Save started');
    
    this.service.triggerSave().then(isHaveErrors => {
      if (!isHaveErrors) {
        this.mail.IDAuc = this.service.currentOtherKp.id;

        this.http.post<boolean>(apiServer + "/otherKp/SendMailToConfirm/", this.mail).subscribe(resp => {
          this.loggingService.logFinish(_xid, 'App.Components.ModalOtherKpSendAdjustmentComponent.onSave', null, 'Save completed');
        }, error => {
          this.loggingService.logError(_xid, 'App.Components.ModalOtherKpSendAdjustmentComponent.onSave', error, null, 'Save failed');
        });
      } else {
        this.loggingService.logFinish(_xid, 'App.Components.ModalOtherKpSendAdjustmentComponent.onSave', null, 'Save skipped due to errors');
      }
      $('#modalOtherKpAdjustmentSender').modal('hide');
    });
  }
}





// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-detail/modal-other-kp-send-adjustment/modal-other-kp-send-adjustment.component.ts